import { render, staticRenderFns } from "./SelectVaStatus.vue?vue&type=template&id=3a94a58c&lang=pug"
import script from "./SelectVaStatus.vue?vue&type=script&lang=js"
export * from "./SelectVaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports